import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFeaturedAnnouncementsAsync: build.query<
      GetFeaturedAnnouncementsAsyncApiResponse,
      GetFeaturedAnnouncementsAsyncApiArg
    >({
      query: () => ({ url: `/blogservice/v1/Announcements/featured` }),
    }),
    getAnnouncementListAsync: build.query<
      GetAnnouncementListAsyncApiResponse,
      GetAnnouncementListAsyncApiArg
    >({
      query: () => ({ url: `/blogservice/v1/Announcements` }),
    }),
    getAnnouncements: build.query<
      GetAnnouncementsApiResponse,
      GetAnnouncementsApiArg
    >({
      query: () => ({ url: `/blogservice/v1/Announcements/GetAnnouncements` }),
    }),
    getAnnouncementAsync: build.query<
      GetAnnouncementAsyncApiResponse,
      GetAnnouncementAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Announcements/${queryArg.announcementId}`,
      }),
    }),
    getAllFaqs: build.query<GetAllFaqsApiResponse, GetAllFaqsApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faqs`,
        params: {
          categoryId: queryArg.categoryId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    createFaqAsync: build.mutation<
      CreateFaqAsyncApiResponse,
      CreateFaqAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faqs`,
        method: 'POST',
        body: queryArg.createFaqCommand,
      }),
    }),
    getFaqById: build.query<GetFaqByIdApiResponse, GetFaqByIdApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faqs/${queryArg.id}`,
      }),
    }),
    updateFaqAsync: build.mutation<
      UpdateFaqAsyncApiResponse,
      UpdateFaqAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faqs/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateFaqRequest,
      }),
    }),
    deleteFaqAsync: build.mutation<
      DeleteFaqAsyncApiResponse,
      DeleteFaqAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faqs/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getAllFaqCategories: build.query<
      GetAllFaqCategoriesApiResponse,
      GetAllFaqCategoriesApiArg
    >({
      query: () => ({ url: `/blogservice/v1/Backoffice/faq-categories` }),
    }),
    createFaqCategoryAsync: build.mutation<
      CreateFaqCategoryAsyncApiResponse,
      CreateFaqCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faq-categories`,
        method: 'POST',
        body: queryArg.createFaqCategoryCommand,
      }),
    }),
    getFaqCategoryById: build.query<
      GetFaqCategoryByIdApiResponse,
      GetFaqCategoryByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faq-categories/${queryArg.id}`,
      }),
    }),
    updateFaqCategoryAsync: build.mutation<
      UpdateFaqCategoryAsyncApiResponse,
      UpdateFaqCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faq-categories/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateFaqCategoryRequest,
      }),
    }),
    deleteFaqCategoryAsync: build.mutation<
      DeleteFaqCategoryAsyncApiResponse,
      DeleteFaqCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/faq-categories/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    createContactInfo: build.mutation<
      CreateContactInfoApiResponse,
      CreateContactInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/contact-info`,
        method: 'POST',
        body: queryArg.createContactInfoRequest,
      }),
    }),
    getAllContactInfos: build.query<
      GetAllContactInfosApiResponse,
      GetAllContactInfosApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/contact-info`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    deleteContactInfo: build.mutation<
      DeleteContactInfoApiResponse,
      DeleteContactInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/contact-info/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    updateContactInfo: build.mutation<
      UpdateContactInfoApiResponse,
      UpdateContactInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/contact-info/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateContactInfoRequest,
      }),
    }),
    getContactInfoById: build.query<
      GetContactInfoByIdApiResponse,
      GetContactInfoByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/backoffice/contact-info/${queryArg.id}`,
      }),
    }),
    reorderContactInfo: build.mutation<
      ReorderContactInfoApiResponse,
      ReorderContactInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/contact-info/${queryArg.id}/reorder`,
        method: 'PATCH',
        body: queryArg.reorderContactInfoRequest,
      }),
    }),
    getAllBlogs: build.query<GetAllBlogsApiResponse, GetAllBlogsApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blogs`,
        params: {
          CategoryId: queryArg.categoryId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    updateBlogAsync: build.mutation<
      UpdateBlogAsyncApiResponse,
      UpdateBlogAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blogs`,
        method: 'PUT',
        body: queryArg.updateBlogRequest,
      }),
    }),
    createBlogAsync: build.mutation<
      CreateBlogAsyncApiResponse,
      CreateBlogAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blogs`,
        method: 'POST',
        body: queryArg.blogCreateRequest,
      }),
    }),
    getBlogById: build.query<GetBlogByIdApiResponse, GetBlogByIdApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/backoffice/blogs/${queryArg.id}`,
      }),
    }),
    reorderBlog: build.mutation<ReorderBlogApiResponse, ReorderBlogApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blogs/${queryArg.id}/reorder`,
        method: 'PATCH',
        body: queryArg.reorderBlogRequest,
      }),
    }),
    generateShareLinks: build.mutation<
      GenerateShareLinksApiResponse,
      GenerateShareLinksApiArg
    >({
      query: () => ({
        url: `/blogservice/v1/Backoffice/generate-share-links`,
        method: 'POST',
      }),
    }),
    deleteBlogAsync: build.mutation<
      DeleteBlogAsyncApiResponse,
      DeleteBlogAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blogs/${queryArg.blogId}`,
        method: 'DELETE',
      }),
    }),
    getAllBlogCategories: build.query<
      GetAllBlogCategoriesApiResponse,
      GetAllBlogCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blog-categories/${queryArg.categoryType}`,
      }),
    }),
    getCategoryById: build.query<
      GetCategoryByIdApiResponse,
      GetCategoryByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/backoffice/blog-categories/${queryArg.id}`,
      }),
    }),
    updateCategoryAsync: build.mutation<
      UpdateCategoryAsyncApiResponse,
      UpdateCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blog-categories/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.categoryUpdateRequest,
      }),
    }),
    deleteCategoryAsync: build.mutation<
      DeleteCategoryAsyncApiResponse,
      DeleteCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blog-categories/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    createCategoryAsync: build.mutation<
      CreateCategoryAsyncApiResponse,
      CreateCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/blog-categories`,
        method: 'POST',
        body: queryArg.categoryCreateRequest,
      }),
    }),
    createAppContract: build.mutation<
      CreateAppContractApiResponse,
      CreateAppContractApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/app-contracts`,
        method: 'POST',
        body: queryArg.createAppContractRequest,
      }),
    }),
    deleteAppContract: build.mutation<
      DeleteAppContractApiResponse,
      DeleteAppContractApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/app-contracts/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    updateAppContract: build.mutation<
      UpdateAppContractApiResponse,
      UpdateAppContractApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/app-contracts/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateAppContractRequest,
      }),
    }),
    getAllAppContracts: build.query<
      GetAllAppContractsApiResponse,
      GetAllAppContractsApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/backoffice/app-contracts`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getAppContractById: build.query<
      GetAppContractByIdApiResponse,
      GetAppContractByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/backoffice/app-contracts/${queryArg.id}`,
      }),
    }),
    getAllAnnouncements: build.query<
      GetAllAnnouncementsApiResponse,
      GetAllAnnouncementsApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/announcements`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    updateAnnouncementAsync: build.mutation<
      UpdateAnnouncementAsyncApiResponse,
      UpdateAnnouncementAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/announcements`,
        method: 'PUT',
        body: queryArg.announcementUpdateRequest,
      }),
    }),
    createAnnouncementAsync: build.mutation<
      CreateAnnouncementAsyncApiResponse,
      CreateAnnouncementAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/announcements`,
        method: 'POST',
        body: queryArg.announcementCreateRequest,
      }),
    }),
    getAnnouncementById: build.query<
      GetAnnouncementByIdApiResponse,
      GetAnnouncementByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/backoffice/announcements/${queryArg.id}`,
      }),
    }),
    reorderAnnouncement: build.mutation<
      ReorderAnnouncementApiResponse,
      ReorderAnnouncementApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/announcements/${queryArg.id}/reorder`,
        method: 'PATCH',
        body: queryArg.reorderAnnouncementRequest,
      }),
    }),
    deleteAnnouncementAsync: build.mutation<
      DeleteAnnouncementAsyncApiResponse,
      DeleteAnnouncementAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Backoffice/announcements/${queryArg.announcementId}`,
        method: 'DELETE',
      }),
    }),
    getBlogsAsync: build.query<GetBlogsAsyncApiResponse, GetBlogsAsyncApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Blogs/all`,
        params: {
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    getBlogsByCategoryAsync: build.query<
      GetBlogsByCategoryAsyncApiResponse,
      GetBlogsByCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Blogs/category/${queryArg.categoryId}`,
        params: {
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    getHighlightedHomeBlogsAsync: build.query<
      GetHighlightedHomeBlogsAsyncApiResponse,
      GetHighlightedHomeBlogsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Blogs/highlighted-home/${queryArg.categoryType}`,
      }),
    }),
    getHighlightedByCategoryAsync: build.query<
      GetHighlightedByCategoryAsyncApiResponse,
      GetHighlightedByCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Blogs/highlighted/${queryArg.categoryId}/${queryArg.take}`,
      }),
    }),
    getBlogAsync: build.query<GetBlogAsyncApiResponse, GetBlogAsyncApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Blogs/${queryArg.blogId}`,
      }),
    }),
    getCategoriesByTypeAsync: build.query<
      GetCategoriesByTypeAsyncApiResponse,
      GetCategoriesByTypeAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Categories/CategoryType/${queryArg.categoryType}`,
      }),
    }),
    getCategoryAsync: build.query<
      GetCategoryAsyncApiResponse,
      GetCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Categories/${queryArg.id}`,
      }),
    }),
    getFaqCategoriesAsync: build.query<
      GetFaqCategoriesAsyncApiResponse,
      GetFaqCategoriesAsyncApiArg
    >({
      query: () => ({ url: `/blogservice/v1/FaqCategories` }),
    }),
    getFaqCategoryAsync: build.query<
      GetFaqCategoryAsyncApiResponse,
      GetFaqCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/FaqCategories/${queryArg.id}`,
      }),
    }),
    getFeaturedFaqsAsync: build.query<
      GetFeaturedFaqsAsyncApiResponse,
      GetFeaturedFaqsAsyncApiArg
    >({
      query: () => ({ url: `/blogservice/v1/Faqs/featured` }),
    }),
    getFaqAsync: build.query<GetFaqAsyncApiResponse, GetFaqAsyncApiArg>({
      query: (queryArg) => ({ url: `/blogservice/v1/Faqs/${queryArg.id}` }),
    }),
    getFaqsByCategoryAsync: build.query<
      GetFaqsByCategoryAsyncApiResponse,
      GetFaqsByCategoryAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/Faqs/by-category/${queryArg.categoryId}`,
        params: {
          searchTerm: queryArg.searchTerm,
        },
      }),
    }),
    getFaqsAsync: build.query<GetFaqsAsyncApiResponse, GetFaqsAsyncApiArg>({
      query: (queryArg) => ({
        url: `/blogservice/v1/Faqs`,
        params: {
          searchTerm: queryArg.searchTerm,
        },
      }),
    }),
    getUserFavoriteBlogsAsync: build.query<
      GetUserFavoriteBlogsAsyncApiResponse,
      GetUserFavoriteBlogsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/FavoriteBlogs`,
        params: {
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    createFavoriteBlogAsync: build.mutation<
      CreateFavoriteBlogAsyncApiResponse,
      CreateFavoriteBlogAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/FavoriteBlogs`,
        method: 'POST',
        body: queryArg.favoriteBlogCreateRequest,
      }),
    }),
    deleteFavoriteBlogAsync: build.mutation<
      DeleteFavoriteBlogAsyncApiResponse,
      DeleteFavoriteBlogAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/blogservice/v1/FavoriteBlogs/${queryArg.blogId}`,
        method: 'DELETE',
      }),
    }),
    triggerAsync: build.mutation<TriggerAsyncApiResponse, TriggerAsyncApiArg>({
      query: () => ({
        url: `/blogservice/v1/Jobs/finance-news-import/trigger`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as blogApi };
export type GetFeaturedAnnouncementsAsyncApiResponse =
  /** status 200 OK */ AnnouncementViewModel[];
export type GetFeaturedAnnouncementsAsyncApiArg = void;
export type GetAnnouncementListAsyncApiResponse =
  /** status 200 OK */ AnnouncementViewModel[];
export type GetAnnouncementListAsyncApiArg = void;
export type GetAnnouncementsApiResponse =
  /** status 200 OK */ AnnouncementViewModel[];
export type GetAnnouncementsApiArg = void;
export type GetAnnouncementAsyncApiResponse =
  /** status 200 OK */ AnnouncementViewModel;
export type GetAnnouncementAsyncApiArg = {
  announcementId: string;
};
export type GetAllFaqsApiResponse =
  /** status 200 OK */ FaqReadModelPaginationResponseRead;
export type GetAllFaqsApiArg = {
  categoryId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type CreateFaqAsyncApiResponse = /** status 201 Created */ FaqIdRead;
export type CreateFaqAsyncApiArg = {
  createFaqCommand: CreateFaqCommand;
};
export type GetFaqByIdApiResponse = /** status 200 OK */ FaqReadModel;
export type GetFaqByIdApiArg = {
  id: string;
};
export type UpdateFaqAsyncApiResponse = unknown;
export type UpdateFaqAsyncApiArg = {
  id: string;
  updateFaqRequest: UpdateFaqRequest;
};
export type DeleteFaqAsyncApiResponse = unknown;
export type DeleteFaqAsyncApiArg = {
  id: string;
};
export type GetAllFaqCategoriesApiResponse =
  /** status 200 OK */ FaqCategoryReadModel[];
export type GetAllFaqCategoriesApiArg = void;
export type CreateFaqCategoryAsyncApiResponse = unknown;
export type CreateFaqCategoryAsyncApiArg = {
  createFaqCategoryCommand: CreateFaqCategoryCommand;
};
export type GetFaqCategoryByIdApiResponse =
  /** status 200 OK */ FaqCategoryReadModel;
export type GetFaqCategoryByIdApiArg = {
  id: string;
};
export type UpdateFaqCategoryAsyncApiResponse = unknown;
export type UpdateFaqCategoryAsyncApiArg = {
  id: string;
  updateFaqCategoryRequest: UpdateFaqCategoryRequest;
};
export type DeleteFaqCategoryAsyncApiResponse = unknown;
export type DeleteFaqCategoryAsyncApiArg = {
  id: string;
};
export type CreateContactInfoApiResponse = /** status 200 OK */ string;
export type CreateContactInfoApiArg = {
  createContactInfoRequest: CreateContactInfoRequest;
};
export type GetAllContactInfosApiResponse =
  /** status 200 OK */ ContactInfoReadModelPaginationResponseRead;
export type GetAllContactInfosApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type DeleteContactInfoApiResponse = /** status 200 OK */ boolean;
export type DeleteContactInfoApiArg = {
  id: string;
};
export type UpdateContactInfoApiResponse = /** status 200 OK */ boolean;
export type UpdateContactInfoApiArg = {
  id: string;
  updateContactInfoRequest: UpdateContactInfoRequest;
};
export type GetContactInfoByIdApiResponse =
  /** status 200 OK */ ContactInfoReadModel;
export type GetContactInfoByIdApiArg = {
  id: string;
};
export type ReorderContactInfoApiResponse = /** status 200 OK */ boolean;
export type ReorderContactInfoApiArg = {
  id: string;
  reorderContactInfoRequest: ReorderContactInfoRequest;
};
export type GetAllBlogsApiResponse =
  /** status 200 OK */ BlogReadModelPaginationResponseRead;
export type GetAllBlogsApiArg = {
  categoryId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type UpdateBlogAsyncApiResponse = unknown;
export type UpdateBlogAsyncApiArg = {
  updateBlogRequest: UpdateBlogRequest;
};
export type CreateBlogAsyncApiResponse = /** status 201 Created */ string;
export type CreateBlogAsyncApiArg = {
  blogCreateRequest: BlogCreateRequest;
};
export type GetBlogByIdApiResponse = /** status 200 OK */ BlogReadModel;
export type GetBlogByIdApiArg = {
  id: string;
};
export type ReorderBlogApiResponse = /** status 200 OK */ boolean;
export type ReorderBlogApiArg = {
  id: string;
  reorderBlogRequest: ReorderBlogRequest;
};
export type GenerateShareLinksApiResponse =
  /** status 200 OK */ GenerateShareLinksResponse;
export type GenerateShareLinksApiArg = void;
export type DeleteBlogAsyncApiResponse = unknown;
export type DeleteBlogAsyncApiArg = {
  blogId: string;
};
export type GetAllBlogCategoriesApiResponse =
  /** status 200 OK */ CategoryViewModel[];
export type GetAllBlogCategoriesApiArg = {
  /** Possible values: blog, finance, fit */
  categoryType: CategoryType;
};
export type GetCategoryByIdApiResponse = /** status 200 OK */ CategoryReadModel;
export type GetCategoryByIdApiArg = {
  id: string;
};
export type UpdateCategoryAsyncApiResponse = unknown;
export type UpdateCategoryAsyncApiArg = {
  id: string;
  categoryUpdateRequest: CategoryUpdateRequest;
};
export type DeleteCategoryAsyncApiResponse = unknown;
export type DeleteCategoryAsyncApiArg = {
  id: string;
};
export type CreateCategoryAsyncApiResponse = /** status 201 Created */ string;
export type CreateCategoryAsyncApiArg = {
  categoryCreateRequest: CategoryCreateRequest;
};
export type CreateAppContractApiResponse = /** status 200 OK */ string;
export type CreateAppContractApiArg = {
  createAppContractRequest: CreateAppContractRequest;
};
export type DeleteAppContractApiResponse = /** status 200 OK */ boolean;
export type DeleteAppContractApiArg = {
  id: string;
};
export type UpdateAppContractApiResponse = /** status 200 OK */ boolean;
export type UpdateAppContractApiArg = {
  id: string;
  updateAppContractRequest: UpdateAppContractRequest;
};
export type GetAllAppContractsApiResponse =
  /** status 200 OK */ AppContractReadModelPaginationResponseRead;
export type GetAllAppContractsApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetAppContractByIdApiResponse =
  /** status 200 OK */ AppContractReadModel;
export type GetAppContractByIdApiArg = {
  id: string;
};
export type GetAllAnnouncementsApiResponse =
  /** status 200 OK */ AnnouncementReadModelPaginationResponseRead;
export type GetAllAnnouncementsApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type UpdateAnnouncementAsyncApiResponse = unknown;
export type UpdateAnnouncementAsyncApiArg = {
  announcementUpdateRequest: AnnouncementUpdateRequest;
};
export type CreateAnnouncementAsyncApiResponse =
  /** status 201 Created */ string;
export type CreateAnnouncementAsyncApiArg = {
  announcementCreateRequest: AnnouncementCreateRequest;
};
export type GetAnnouncementByIdApiResponse =
  /** status 200 OK */ AnnouncementReadModel;
export type GetAnnouncementByIdApiArg = {
  id: string;
};
export type ReorderAnnouncementApiResponse = /** status 200 OK */ boolean;
export type ReorderAnnouncementApiArg = {
  id: string;
  reorderAnnouncementRequest: ReorderAnnouncementRequest;
};
export type DeleteAnnouncementAsyncApiResponse = unknown;
export type DeleteAnnouncementAsyncApiArg = {
  announcementId: string;
};
export type GetBlogsAsyncApiResponse =
  /** status 200 OK */ BlogViewModelGuidCursorPaginationResponse;
export type GetBlogsAsyncApiArg = {
  search?: string;
  cursor: string;
  limit: number;
};
export type GetBlogsByCategoryAsyncApiResponse =
  /** status 200 OK */ BlogViewModelGuidCursorPaginationResponse;
export type GetBlogsByCategoryAsyncApiArg = {
  categoryId: string;
  search?: string;
  cursor: string;
  limit: number;
};
export type GetHighlightedHomeBlogsAsyncApiResponse =
  /** status 200 OK */ BlogViewModel[];
export type GetHighlightedHomeBlogsAsyncApiArg = {
  /** Possible values: blog, finance, fit */
  categoryType: CategoryType;
};
export type GetHighlightedByCategoryAsyncApiResponse =
  /** status 200 OK */ BlogViewModel[];
export type GetHighlightedByCategoryAsyncApiArg = {
  categoryId: string;
  take: number;
};
export type GetBlogAsyncApiResponse = /** status 200 OK */ BlogViewModel;
export type GetBlogAsyncApiArg = {
  blogId: string;
};
export type GetCategoriesByTypeAsyncApiResponse =
  /** status 200 OK */ CategoryViewModel[];
export type GetCategoriesByTypeAsyncApiArg = {
  /** Possible values: blog, finance, fit */
  categoryType: CategoryType;
};
export type GetCategoryAsyncApiResponse =
  /** status 200 OK */ CategoryViewModel;
export type GetCategoryAsyncApiArg = {
  id: string;
};
export type GetFaqCategoriesAsyncApiResponse =
  /** status 200 OK */ FaqCategoryViewModel[];
export type GetFaqCategoriesAsyncApiArg = void;
export type GetFaqCategoryAsyncApiResponse =
  /** status 200 OK */ FaqCategoryViewModel;
export type GetFaqCategoryAsyncApiArg = {
  id: string;
};
export type GetFeaturedFaqsAsyncApiResponse =
  /** status 200 OK */ FaqViewModel[];
export type GetFeaturedFaqsAsyncApiArg = void;
export type GetFaqAsyncApiResponse = /** status 200 OK */ FaqViewModel;
export type GetFaqAsyncApiArg = {
  id: string;
};
export type GetFaqsByCategoryAsyncApiResponse =
  /** status 200 OK */ FaqViewModel[];
export type GetFaqsByCategoryAsyncApiArg = {
  categoryId: string;
  searchTerm?: string;
};
export type GetFaqsAsyncApiResponse = /** status 200 OK */ FaqViewModel[];
export type GetFaqsAsyncApiArg = {
  searchTerm?: string;
};
export type GetUserFavoriteBlogsAsyncApiResponse =
  /** status 200 OK */ FavoriteBlogViewModelGuidCursorPaginationResponse;
export type GetUserFavoriteBlogsAsyncApiArg = {
  search?: string;
  cursor: string;
  limit: number;
};
export type CreateFavoriteBlogAsyncApiResponse = unknown;
export type CreateFavoriteBlogAsyncApiArg = {
  favoriteBlogCreateRequest: FavoriteBlogCreateRequest;
};
export type DeleteFavoriteBlogAsyncApiResponse = unknown;
export type DeleteFavoriteBlogAsyncApiArg = {
  blogId: string;
};
export type TriggerAsyncApiResponse = unknown;
export type TriggerAsyncApiArg = void;
export type AnnouncementViewModel = {
  announcementId?: string;
  title?: string | null;
  description?: string | null;
  summary?: string | null;
  imageUrl?: string | null;
  buttonText?: string | null;
  isFeatured?: boolean;
  orderNo?: number;
  createdAt?: string;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type FaqCategoryReadModel = {
  id?: string;
  name?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  isDeleted?: boolean;
  faqs?: FaqReadModel[] | null;
};
export type FaqReadModel = {
  id?: string;
  title?: string | null;
  description?: string | null;
  faqCategoryId?: string;
  createdAt?: string;
  updatedAt?: string | null;
  isDeleted?: boolean;
  isFeatured?: boolean;
  orderNo?: number;
  faqCategory?: FaqCategoryReadModel;
};
export type FaqReadModelPaginationResponse = {
  items?: FaqReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type FaqReadModelPaginationResponseRead = {
  items?: FaqReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type FaqId = {};
export type FaqIdRead = {
  value?: string;
};
export type CreateFaqCommand = {
  title?: string | null;
  description?: string | null;
  faqCategoryId?: string;
  isFeatured?: boolean;
  orderNo?: number;
};
export type UpdateFaqRequest = {
  title?: string | null;
  description?: string | null;
  categoryId?: string;
  isFeatured?: boolean;
  orderNo?: number;
};
export type CreateFaqCategoryCommand = {
  name?: string | null;
};
export type UpdateFaqCategoryRequest = {
  name?: string | null;
};
export type CreateContactInfoRequest = {
  name?: string | null;
  text?: string | null;
  type?: string | null;
  isEnabled?: boolean;
  imageUrl?: string | null;
  urlLink?: string | null;
  orderNo?: number;
};
export type ContactInfoReadModel = {
  id?: string;
  name?: string | null;
  text?: string | null;
  type?: string | null;
  isEnabled?: boolean;
  imageUrl?: string | null;
  urlLink?: string | null;
  orderNo?: number;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ContactInfoReadModelPaginationResponse = {
  items?: ContactInfoReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type ContactInfoReadModelPaginationResponseRead = {
  items?: ContactInfoReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type UpdateContactInfoRequest = {
  name?: string | null;
  text?: string | null;
  type?: string | null;
  isEnabled?: boolean;
  imageUrl?: string | null;
  urlLink?: string | null;
  orderNo?: number;
};
export type ReorderContactInfoRequest = {
  newOrderNo?: number;
};
export type CategoryType = 'blog' | 'finance' | 'fit';
export type CategoryReadModel = {
  id?: string;
  name?: string | null;
  isFeatured?: boolean;
  categoryType?: CategoryType;
  createdAt?: string;
  updatedAt?: string | null;
};
export type FavoriteBlogReadModel = {
  id?: string;
  blogId?: string;
  blog?: BlogReadModel;
  userId?: string | null;
  createdAt?: string;
};
export type BlogReadModel = {
  id?: string;
  title?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  readTime?: number;
  categoryId?: string;
  category?: CategoryReadModel;
  createdAt?: string;
  isDeleted?: boolean;
  isHighlighted?: boolean;
  isHighlightedHome?: boolean;
  shareLink?: string | null;
  blogs?: FavoriteBlogReadModel[] | null;
};
export type BlogReadModelPaginationResponse = {
  items?: BlogReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type BlogReadModelPaginationResponseRead = {
  items?: BlogReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type UpdateBlogRequest = {
  /** ID of the blog post to update */
  id?: string;
  /** Updated title of the blog post */
  title?: string | null;
  /** Updated content of the blog post */
  description?: string | null;
  imageUrl?: string | null;
  readTime?: number;
  /** Updated category ID */
  categoryId?: string;
  /** Whether this blog post should be highlighted */
  isHighlighted?: boolean;
  /** Whether this blog post should be highlighted on the home page */
  isHighlightedHome?: boolean;
};
export type BlogCreateRequest = {
  /** Title of the blog post */
  title?: string | null;
  /** Content of the blog post */
  description?: string | null;
  /** ID of the category this blog post belongs to */
  categoryId?: string;
  imageUrl?: string | null;
  readTime?: number;
  /** Whether this blog post should be highlighted */
  isHighlighted?: boolean;
  /** Whether this blog post should be highlighted on the home page */
  isHighlightedHome?: boolean;
};
export type ReorderBlogRequest = {
  newOrderNo?: number;
};
export type GenerateShareLinksResponse = {
  totalBlogs?: number;
  successCount?: number;
  failureCount?: number;
  failedBlogIds?: string[] | null;
};
export type CategoryViewModel = {
  id?: string;
  name?: string | null;
  categoryType?: CategoryType;
  createdAt?: string;
  isFeatured?: boolean;
};
export type CategoryUpdateRequest = {
  /** Name of the category */
  name?: string | null;
  categoryType?: CategoryType;
  /** Whether this is a future category */
  isFeatured?: boolean;
};
export type CategoryCreateRequest = {
  /** Name of the category */
  name?: string | null;
  categoryType?: CategoryType;
  /** Whether this is a future category */
  isFeatured?: boolean;
};
export type CreateAppContractRequest = {
  text?: string | null;
  isEnabled?: boolean;
  urlLink?: string | null;
};
export type UpdateAppContractRequest = {
  text?: string | null;
  isEnabled?: boolean;
  urlLink?: string | null;
};
export type AppContractReadModel = {
  id?: string;
  text?: string | null;
  isEnabled?: boolean;
  urlLink?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type AppContractReadModelPaginationResponse = {
  items?: AppContractReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type AppContractReadModelPaginationResponseRead = {
  items?: AppContractReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type AnnouncementReadModel = {
  id?: string;
  title?: string | null;
  description?: string | null;
  summary?: string | null;
  imageUrl?: string | null;
  buttonText?: string | null;
  isFeatured?: boolean;
  orderNo?: number;
  createdAt?: string;
  isDeleted?: boolean;
};
export type AnnouncementReadModelPaginationResponse = {
  items?: AnnouncementReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type AnnouncementReadModelPaginationResponseRead = {
  items?: AnnouncementReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type AnnouncementUpdateRequest = {
  /** ID of the announcement to update */
  id?: string;
  /** Updated title of the announcement */
  title?: string | null;
  /** Updated content of the announcement */
  content?: string | null;
  summary?: string | null;
  imageUrl?: string | null;
  isFeatured?: boolean;
  buttonText?: string | null;
  orderNo?: number;
};
export type AnnouncementCreateRequest = {
  /** Title of the announcement */
  title?: string | null;
  /** Content of the announcement */
  content?: string | null;
  summary?: string | null;
  imageUrl?: string | null;
  buttonText?: string | null;
  isFeatured?: boolean;
  orderNo?: number;
};
export type ReorderAnnouncementRequest = {
  newOrderNo?: number;
};
export type BlogViewModel = {
  id?: string;
  title?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  readTime?: number;
  category?: CategoryViewModel;
  createdAt?: string;
  isHighlighted?: boolean;
  isHighlightedHome?: boolean;
  shareLink?: string | null;
  isFavorite?: boolean;
};
export type BlogViewModelGuidCursorPaginationResponse = {
  items?: BlogViewModel[] | null;
  cursor?: string;
  hasMore?: boolean;
};
export type FaqViewModel = {
  id?: string;
  title?: string | null;
  description?: string | null;
  faqCategoryId?: string;
  createdAt?: string;
  updatedAt?: string | null;
  faqCategory?: FaqCategoryViewModel;
  isFeatured?: boolean;
  orderNo?: number;
};
export type FaqCategoryViewModel = {
  id?: string;
  name?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  faqs?: FaqViewModel[] | null;
};
export type FavoriteBlogViewModel = {
  userId?: string | null;
  blog?: BlogViewModel[] | null;
};
export type FavoriteBlogViewModelGuidCursorPaginationResponse = {
  items?: FavoriteBlogViewModel[] | null;
  cursor?: string;
  hasMore?: boolean;
};
export type FavoriteBlogCreateRequest = {
  /** ID of the blog to add to favorites */
  blogId?: string;
};
export const {
  useGetFeaturedAnnouncementsAsyncQuery,
  useGetAnnouncementListAsyncQuery,
  useGetAnnouncementsQuery,
  useGetAnnouncementAsyncQuery,
  useGetAllFaqsQuery,
  useCreateFaqAsyncMutation,
  useGetFaqByIdQuery,
  useUpdateFaqAsyncMutation,
  useDeleteFaqAsyncMutation,
  useGetAllFaqCategoriesQuery,
  useCreateFaqCategoryAsyncMutation,
  useGetFaqCategoryByIdQuery,
  useUpdateFaqCategoryAsyncMutation,
  useDeleteFaqCategoryAsyncMutation,
  useCreateContactInfoMutation,
  useGetAllContactInfosQuery,
  useDeleteContactInfoMutation,
  useUpdateContactInfoMutation,
  useGetContactInfoByIdQuery,
  useReorderContactInfoMutation,
  useGetAllBlogsQuery,
  useUpdateBlogAsyncMutation,
  useCreateBlogAsyncMutation,
  useGetBlogByIdQuery,
  useReorderBlogMutation,
  useGenerateShareLinksMutation,
  useDeleteBlogAsyncMutation,
  useGetAllBlogCategoriesQuery,
  useGetCategoryByIdQuery,
  useUpdateCategoryAsyncMutation,
  useDeleteCategoryAsyncMutation,
  useCreateCategoryAsyncMutation,
  useCreateAppContractMutation,
  useDeleteAppContractMutation,
  useUpdateAppContractMutation,
  useGetAllAppContractsQuery,
  useGetAppContractByIdQuery,
  useGetAllAnnouncementsQuery,
  useUpdateAnnouncementAsyncMutation,
  useCreateAnnouncementAsyncMutation,
  useGetAnnouncementByIdQuery,
  useReorderAnnouncementMutation,
  useDeleteAnnouncementAsyncMutation,
  useGetBlogsAsyncQuery,
  useGetBlogsByCategoryAsyncQuery,
  useGetHighlightedHomeBlogsAsyncQuery,
  useGetHighlightedByCategoryAsyncQuery,
  useGetBlogAsyncQuery,
  useGetCategoriesByTypeAsyncQuery,
  useGetCategoryAsyncQuery,
  useGetFaqCategoriesAsyncQuery,
  useGetFaqCategoryAsyncQuery,
  useGetFeaturedFaqsAsyncQuery,
  useGetFaqAsyncQuery,
  useGetFaqsByCategoryAsyncQuery,
  useGetFaqsAsyncQuery,
  useGetUserFavoriteBlogsAsyncQuery,
  useCreateFavoriteBlogAsyncMutation,
  useDeleteFavoriteBlogAsyncMutation,
  useTriggerAsyncMutation,
} = injectedRtkApi;
